import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-tabulator-checkbox',
  templateUrl: './tabulator-checkbox.component.html',
  styleUrls: ['./tabulator-checkbox.component.css']
})
export class TabulatorCheckboxComponent implements OnInit {

  @Input() isChecked: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
